import { formatDateWithFormat } from "common/dates";
import { useMemo } from "react";
import * as staticDataService from "services/staticDataService";

const DEFAULT_FORMAT = "YYYY-MM-DD";

export const useDateConfigFormat = (configKey) => {
  const { data: dateFormatConfig } = staticDataService.useConfigQuery(
    "date_format"
  );
  return useMemo(
    () =>
      dateFormatConfig?.[configKey] ?? dateFormatConfig?.date_format ?? null,
    [dateFormatConfig, configKey]
  );
};

export const useFormattedDate = (
  configKey,
  value,
  { placeholder = "", defaultFormat } = {}
) => {
  const formatStr = useDateConfigFormat(configKey);
  return useMemo(() => {
    if (value == null || value === "") return placeholder;
    const format = formatStr ?? defaultFormat ?? DEFAULT_FORMAT;
    return formatDateWithFormat(value, format);
  }, [value, formatStr, placeholder, defaultFormat]);
};

const FormattedDate = ({
  configKey,
  value,
  placeholder = "",
  defaultFormat,
}) => {
  const formatted = useFormattedDate(configKey, value, {
    placeholder,
    defaultFormat,
  });
  return <>{formatted}</>;
};

export default FormattedDate;
